require('./brokerStocksAdvancedSellStep3.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;
const {
    SECOND_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');
const { BROKER_STOCKS_ADVANCED_BUY_ID } = require('constants/operationTypes');

// @commons
const AdvancedBuySellStockSummary = require('components/broker/commons/advancedBuySellStockSummary/advancedBuySellStockSummary');
const { OKMessage } = require('commonsComponents/OKMessage');

// @components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

const BrokerStocksAdvancedSellStep3 = props => {
    const {
        immProductFile,
        immBrokerStocksAdvancedSell,
        immStocksContract,
        immSearchState
    } = props;
    const step2 = immBrokerStocksAdvancedSell.getIn(['steps', SECOND_STEP]);
    const selectedOptionValue = step2.get('selectedOptionValue');
    const selectedStockContract = immStocksContract.find(contract => {
        return contract.get('contactNumber') === selectedOptionValue;
    });

    if (!selectedStockContract) {
        return;
    }

    const operationParams = {
        chargeAccount:
            CHARGE_ACCOUNT_PREFIX +
            selectedStockContract.get('productNumber') +
            selectedStockContract.get('walletNumber'),
        bondsNumber: immBrokerStocksAdvancedSell.getIn([
            'validationServiceResponse',
            'numTitulos'
        ])
    };

    return (
        <div className="stocks-advanced-sell-step3">
            <header className="stocks-advanced-sell-step3__header">
                <h2 className="stocks-advanced-sell-step3__header-title">
                    <FormattedText value="broker-stocksAdvancedSellStep3HeaderTitle" />
                </h2>
                <p className="stocks-advanced-sell-step3__header-text">
                    <FormattedText value="broker-stocksAdvancedSellStep3HeaderText" />
                </p>
            </header>
            <AdvancedBuySellStockSummary
                immProductFile={immProductFile}
                immBrokerStocksAdvancedState={immBrokerStocksAdvancedSell}
                immStocksContract={immStocksContract}
                immSearchState={immSearchState}
                modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_SELL_MODIFIER}
            />
            <footer className="stocks-advanced-sell-step3__section">
                <SignaturePattern
                    operationType={BROKER_STOCKS_ADVANCED_BUY_ID}
                    operationParams={operationParams}
                />
                <div className="stocks-advanced-sell-step3__disclaimer">
                    <OKMessage
                        id="stocks-advanced-sell-step3-disclaimer"
                        type="warning"
                        visible={true}
                    >
                        <FormattedText value="broker-stocksAdvancedSellStep3DisclaimerText" />
                    </OKMessage>
                </div>
                <FormattedText value="broker-stocksAdvancedSellStep3FooterText" />
            </footer>
        </div>
    );
};

BrokerStocksAdvancedSellStep3.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerStocksAdvancedSell: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired,
    immSearchState: PropTypes.object.isRequired
};

module.exports = BrokerStocksAdvancedSellStep3;
